import React, { Component } from "react";
import { TenantReqProps } from "./TenantRequestsListView";
import GridDataView, { GRID_SIZE } from "@my-dld/components/DataView/GridDataView";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import { TenancyRequest } from "@eres/ejari-api/Entity/tenant";
import {
	getTenantReqAmount,
	getTenantReqBuildingName,
	getTenantReqContractNo,
	getTenantReqEndDate,
	getTenantReqPropertyTypeName,
	getTenantReqStartDate,
	getTenantReqStatus,
	getTenantReqUnitNo
} from "../../screens/Tenant/Requests/MyTenantRequests";
import Strings from "@my-dld/assets/strings";
import { getTenantRequestStatusClass, IDtoEnum } from "@eres/ejari-api/Utils";
import { EjariPropertyType } from "@eres/ejari-api/Entity";

interface State {
	searchKey?: string;
	page: number;
}

class TenantRequestsGridView extends Component<TenantReqProps, State> {
	constructor( props: TenantReqProps ) {
		super( props );
		this.state = {
			page: 1,
		};
	}

	render() {
		const { items, onDetails } = this.props;
		const { searchKey } = this.state;
		const filterData = this.getFilterData( searchKey );
		return <GridDataView
			items={ this.getPageData( filterData ) }
			onSearch={ this.onSearch }
			renderGridItem={ ( item: TenancyRequest, index: number ) => {
				return <RenderGridItem
					key={ `${ index }_${ item.ContractNumber }` }
					item={ item }
					onDetails={ onDetails }/>;
			} }
			totalCount={ !isEmptyStringOrNull( searchKey ) ? filterData.length : items.length }
			onPageChange={ this.onPageChange }/>;
	}

	private getFilterData( sKey?: string ) {
		const { items } = this.props;
		if ( sKey ) {
			return items.filter( ( item: TenancyRequest ) => {
				const propertyType = IDtoEnum<EjariPropertyType>( EjariPropertyType, item.PropertyTypeID )!;
				const filterKeys: string[] = [];
				filterKeys.push( getTenantReqPropertyTypeName( propertyType ) );
				filterKeys.push( getTenantReqStatus( item ) );
				filterKeys.push( getTenantReqUnitNo( item, propertyType ) );
				filterKeys.push( getTenantReqStartDate( item ) );
				filterKeys.push( getTenantReqEndDate( item ) );
				filterKeys.push( getTenantReqContractNo( item ) );
				filterKeys.push( getTenantReqAmount( item ) );
				const fItem = filterKeys.find( ( fKey: string ) => fKey.toLocaleLowerCase().includes( sKey.toLocaleLowerCase() ) );
				return fItem !== undefined;
			} );
		}
		return items;
	}

	private getPageData( filterData: TenancyRequest[] ) {
		const { page } = this.state;
		return filterData.slice( ( page - 1 ) * GRID_SIZE, page * GRID_SIZE );
	}

	private onSearch = ( sKey?: string ) => {
		this.setState( {
			searchKey: sKey,
			page: 1
		} );
	};

	private onPageChange = ( page: number ) => {
		this.setState( { page: page } );
	};
}

function RenderGridItem( props: {
	item: TenancyRequest,
	onDetails: ( request: TenancyRequest ) => void
} ) {
	const { item, onDetails } = props;
	const propertyType = IDtoEnum<EjariPropertyType>( EjariPropertyType, item.PropertyTypeID )!;
	const isUnit = propertyType === EjariPropertyType.UNIT;
	const buildingClass = isUnit ? "col-6" : "col-12";
	return <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 property-card">
		<div className="card">
			<div className="card-body custom-body">
				<div className="detail-holder">
					<div className="custom-card-title">
						<div>
							<span>{ getTenantReqPropertyTypeName( propertyType ) }</span>
							<span>{ Strings.property_type }</span>
						</div>
						<span className={ `property-status ${ getTenantRequestStatusClass( item.Status ) }` }>
                            { getTenantReqStatus( item ) }
                        </span>
					</div>
					<div className="row no-gutters property-card-detail">
						<div className={ buildingClass }>
							<span>{ getTenantReqBuildingName( item ) }</span>
							<span>{ Strings.building_name }</span>
						</div>
						{ isUnit && <div className="col-6">
							<span>{ getTenantReqUnitNo( item, propertyType ) }</span>
							<span>{ Strings.Unit_Number_Label }</span>
						</div> }
					</div>
					<div className="row no-gutters property-card-detail">
						<div className="col-6">
							<span>{ getTenantReqStartDate( item ) }</span>
							<span>{ Strings.contract_start_date }</span>
						</div>
						<div className="col-6">
							<span>{ getTenantReqEndDate( item ) }</span>
							<span>{ Strings.contract_end_date }</span>
						</div>
					</div>
					<div className="row no-gutters property-card-detail">
						<div className="col-6">
							<span>{ getTenantReqContractNo( item ) }</span>
							<span>{ Strings.contract_number }</span>
						</div>
						<div className="col-6">
							<span className="contract-amount">{ getTenantReqAmount( item ) }</span>
							<span>{ Strings.contract_amount_aed }</span>
						</div>
					</div>
					<div className="row no-gutters property-card-action">
						<div className="col-md-12">
							<button
								className="btn-link" onClick={ () => {
								onDetails( item );
							} }>{ Strings.view_details }</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>;
}

export default TenantRequestsGridView;
